import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import { CONFIGURATION_OUTPUT } from './topics';
import type { IPartialConfig } from './configModel';
import { partialConfigSchema } from './configModel';

export const UPDATED = 'CONFIG/UPDATED';

export interface IUpdatedPayload {
  configId: string;
  config: IPartialConfig;
}

export const configUpdatedPayloadSchema = objectSchemaOf<IUpdatedPayload>({
  configId: Joi.string().required(),
  config: partialConfigSchema.required(),
});

export interface IUpdatedAction {
  type: typeof UPDATED;
  payload: IUpdatedPayload;
}

export const updatedActionSchema = objectSchemaOf<IUpdatedAction>({
  type: Joi.string().required().valid(UPDATED),
  payload: configUpdatedPayloadSchema.required(),
});

export const updated = actionCreator({
  schema: updatedActionSchema,
  topic: CONFIGURATION_OUTPUT,
  type: UPDATED,
});
